import React from 'react';
import LocalizedMessage from 'react-l10n';

function CartSummaryHeader(props) {
    return (
        <div className='data-table__header'>
            <div className='data-table__tr' role='row'>
                <div className='data-table__th dt-cart-summary__image' />
                <div className='data-table__th dt-cart-summary__product' />
                <div className='data-table__th dt-cart-summary__price hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'UNIT_PRICE'} />
                    </span>
                </div>
                <div className='data-table__th dt-cart-summary__quantity hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'QUANTITY'} />
                    </span>
                </div>
                <div className='data-table__th dt-cart-summary__total hidden-xs hidden-sm'>
                    <span className='data-table__heading'>
                        <LocalizedMessage id={'TOTAL'} />
                    </span>
                </div>
                <div className='data-table__th' style={{ maxWidth: 45 }} />
            </div>
        </div>
    );
}

// default props
CartSummaryHeader.defaultProps = {
    // message: '',
};
// validate props
CartSummaryHeader.propTypes = {
    // message: PropTypes.string,
};

export default CartSummaryHeader;
